@if (partner) {
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      @if (partner.image && partner.image.url) {
        <div class="float-start profile-picture me-3">
          <img [ngSrc]="imageService.getImageUrl(partner.image, 50, 50)" width="50" height="50" alt="Partner profile picture">
        </div>
      }
      @if (!partner.image || !partner.image.url) {
        <div class="float-start profile-picture me-3">
          <img ngSrc="/images/oktopus-50px.webp" width="50" height="50" alt="Default profile picture">
        </div>
      }
      <div class="float-end">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item active" aria-current="page">
            <a [routerLink]="'/partners'">Partners</a>
          </li>
          <li class="breadcrumb-item" aria-current="page">
            <div class="d-flex align-items-center justify-content-start">
              @if (!partner.prospect) {
                <h1 class="fs-4 fw-bold mb-0 me-2">AffID: {{ partner.id }}</h1>
              }
              @if (partner.prospect) {
                <h1 class="fs-4 fw-bold mb-0 me-2">PROSPECT</h1>
              }
              <span class="badge" [ngClass]="partner.getAccountTypeClass()">{{ 'partnerAccountType.' + partner.accountType | translate }}</span>
              @if (partner.isMediaBuy() && partner.advertisingPlatform) {
                <img [ngSrc]="partnerService.getAdvertisingPlatformImage(partner)" alt=""
                  class="logo-regie" width="80" height="22">
              }
            </div>
          </li>
        </ol>
        <span class="mt-2"><b>Account Name:</b> {{ partner.companyName }}</span>
      </div>
    </div>
    <div class="d-flex gap-2">
      @if (partner.prospect) {
        <button class="btn btn-outline-primary fw-bold" (click)="convertProspect()">
          <i class="bi bi-arrow-right-circle-fill me-2"></i>Convert
        </button>
      }
      <button class="btn btn-outline-primary fw-bold" (click)="openActivityForm('note')">
        <i class="bi bi-plus-lg me-2"></i>Add Note
      </button>
      <button class="btn btn-outline-primary fw-bold" (click)="openActivityForm('task')">
        <i class="bi bi-plus-lg me-2"></i>Add Task
      </button>
      <ng-container>
        <div *isGranted="['ROLE_API_PARTNER_LOGIN']" class="btn-group">
          <button (click)="login()" class="btn btn-primary fw-bold">Login</button>
          <button (click)="openAffiliateUsersModal()" class="btn btn-primary fw-bold"><i class="bi bi-gear-fill"></i></button>
        </div>
      </ng-container>
    </div>
  </div>
}

@if (partner) {
  <ul class="nav nav-tabs mb-3" role="tablist">
    <li *isGranted="['ACTIVITY_VIEW']" class="nav-item" role="presentation">
      <a class="nav-link text-primary fw-bold" [routerLink]="['/partners', partner.id, 'activity']"
      routerLinkActive="active">Activity Feed</a>
    </li>
    <li class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'account-management']" class="nav-link text-primary fw-bold"
      routerLinkActive="active">Account Management</a>
    </li>
    <li class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'behavior-config']" class="nav-link text-primary fw-bold"
      routerLinkActive="active">Behavior config</a>
    </li>
    <li class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'links']" class="nav-link text-primary fw-bold"
      routerLinkActive="active">Links</a>
    </li>
    <li class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'tools']" class="nav-link text-primary fw-bold"
      routerLinkActive="active">Tools</a>
    </li>
    <li class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'offers']" class="nav-link text-primary fw-bold"
      routerLinkActive="active">Offers</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link text-primary fw-bold disabled">AdTracker</a>
    </li>
    <li *isGranted="['POSTBACK_VIEW']" class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'tracking', 'postback']"
        [ngClass]="getActiveMenuClass('/tracking/')"
        class="nav-link text-primary fw-bold">
        Tracking &amp; Postback
      </a>
    </li>
    @if (isAffiliate() && isGranted(['CUSTOM_PAYOUT_VIEW'])) {
      <li class="nav-item" role="presentation">
        <a [routerLink]="['/partners', partner.id, 'custom-payouts']" class="nav-link text-primary fw-bold"
        routerLinkActive="active">Custom payouts</a>
      </li>
    }
    <li class="nav-item" role="presentation">
      <a class="nav-link text-primary fw-bold disabled">Performance Adjustment</a>
    </li>
    <li *isGranted="['AFFILIATE_PAYMENT_VIEW']" class="nav-item" role="presentation">
      <a [routerLink]="['/partners', partner.id, 'payment']" class="nav-link text-primary fw-bold"
      routerLinkActive="active">Accounting</a>
    </li>
  </ul>
}

<div class="tab-content">
  <router-outlet></router-outlet>
</div>
